import { useState, useEffect } from "react";
import {
  getFromLocalStorage,
  storeToLocalStorage,
  deleteFromLocalStorage
} from "../utils/localStorageHelpers";
import { Activity } from "./Activity";

const ACTIVITIES_LOCAL_STORAGE_KEY = "ACTIVITIES";

export default function useActivities() {
  const [activities, setActivities] = useState<Activity[]>([]);

  useEffect(() => {
    const storedState = getFromLocalStorage<Activity[]>(
      ACTIVITIES_LOCAL_STORAGE_KEY
    );
    if (storedState && Array.isArray(storedState)) {
      setActivities(storedState);
    }
  }, []);

  useEffect(() => {
    storeToLocalStorage(ACTIVITIES_LOCAL_STORAGE_KEY, activities);
  }, [activities]);

  const addActivity = (activity: Activity) => {
    activity.id = Math.random().toString(36);
    setActivities([...activities, activity]);
  };

  const updateActivity = (activity: Activity) => {
    setActivities(activities.map(a => (a.id === activity.id ? activity : a)));
  };

  const removeActivity = (id: string) => {
    setActivities(activities.filter(a => a.id !== id));
  };

  const clearAllActivities = () => {
    deleteFromLocalStorage(ACTIVITIES_LOCAL_STORAGE_KEY);
    setActivities([]);
  };

  const restoreActivities = (activities: Activity[]) => {
    setActivities(
      activities.map(a => ({ ...a, id: Math.random().toString(36) }))
    );
  };

  return {
    activities,
    addActivity,
    updateActivity,
    removeActivity,
    clearAllActivities,
    restoreActivities
  };
}
